/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import { useEffect } from "react";
// Fix for process
import 'process';

// Fix global performance object for older browsers
if (typeof window !== 'undefined' && typeof window.performance === 'undefined') {
  window.performance = { now: () => new Date().getTime() };
}

// Set up global namespace for polyfills
export const onClientEntry = () => {
  // Add any necessary polyfills here
  // Enables RSS feed to work properly in development
  if (typeof window.Node === 'undefined') {
    window.Node = {
      ELEMENT_NODE: 1,
      TEXT_NODE: 3,
    };
  }
};

export const onInitialClientRender = () => {
  const netlifyIdentity = window.netlifyIdentity;
  if (netlifyIdentity) {
    netlifyIdentity.on("init", user => {
      if (!user) {
        netlifyIdentity.on("login", () => {
          document.location.href = "/admin/";
        });
      }
    });
  }
};
